const applyColorOpacity = (color: string, alpha: number) => {
  const alpha256 = (alpha * 255).toFixed()
  const alphaBase16 = Number(alpha256).toString(16)
  const paddedAlpha = alphaBase16.length === 1 ?
    alphaBase16.padStart(2, '0') : alphaBase16
  return color.concat('', paddedAlpha)
}

const Colors = {
  black: '#000000',
  white: '#ffffff',
  primary: '#1056AC',
  background: '#F6F6F6',
  transparent: '#00000000',
  green: {
    bg: '#E9F3ED',
    primary: '#1E874B',
    lightPrimary: applyColorOpacity('#1E874B', 0.10),
    whatsappColor: '#12AF0A',
  },
  cyan: {
    bg: '#20c6a6'
  },
  blue: {
    bg: '#E1F5FF',
    cta: '#1056AC',
    darkBlue: '#1530A4',
    blurColor: '#0066E6ff',
    oms_detail_card_upper_bg: '#D8E4F2',
    oms_detail_card_lower_bg: '#E2F1FF',
    selected_address_bg: '#F1F5F9',
    toggleColor1: '#0071FF',
    lightTint: '#e9f1f9',
  },
  grey: {
    bg: '#6c6c6c',
    text: '#6C6C6C',
    border: '#C9C9C9',
    disable: '#C9C9C9',
    divider: '#dddddd',
    fillerInfo: '#9e9e9e',
    shadowColor: '#00000029',
    lightText: applyColorOpacity('#000000', 0.60),
    dateTime: '#828282',
    shimmer: '#f6f6f6',
    shimmerBg: '#e0e0e0',
    darkBg: applyColorOpacity('#000000', 0.87),
    opaque: applyColorOpacity('#000000', 0.61),
  },
  orange: {
    activityStatus: '#f2994a',
    text: '#DD6700',
    border: '#DD670033',
    bg: applyColorOpacity('#FCF2E0', 245 / 255),
  },
  red: {
    highlight: '#ED323B',
    bg: '#FEEBEC'
  },
  purple: {
    lightBg: 'ecf3ff',
    border: '#af70c3',
    text: '#8062B0',
    bg: applyColorOpacity('#8062B0', 51 / 255),
  },
  yellow: {},
  violet: { bg: '#0B0559' },
  skyBlue: {
    text: '#00AAC8',
    bg: applyColorOpacity('#00AAC8', 0.33)
  },
  aayuCardColors: {
    premiumPrimary: '#DD6700',
    premiumSecondary: '#fcf2e0',
    premiumText: '#ffffff',
    planText: '#ffffff',
    priceText: '#ffffff',
    savingText: '#ffffff',
    videoBG: '#965aff',
    aayuPlan25: '#5A2A77',
    aayuPlan12: '#794073',
    aayuPlan8: '#075A69',
    aayuPlan5: '#F8C52A',
  },
  chemistSiteLogoBg: [
    '#DB4437', '#E91E63', '#FF5722',
    '#EF6C00', '#689F38', '#0097A7',
    '#4285F4', '#039BE5', '#3F51B5',
    '#673AB7'
  ]
}

export default Colors;